import { Link, useParams } from 'react-router-dom'

import Nav from 'react-bootstrap/Nav'

import { debugSignal } from '../../../state/signals/userSettingsSignals.js'

export default function ProfileNav({ activeKey }) {

    const { beId, profileId } = useParams()

    return (
        <Nav variant="tabs" size="sm" activeKey={activeKey} className="px-3 my-3">
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "1" ? " active" : "")} eventkey="1" to={`/be/${beId}/profiles/${profileId}`}>General</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "2" ? " active" : "")} eventkey="2" to={`/be/${beId}/profiles/${profileId}/apiinterfaces`}>API Interfaces</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "3" ? " active" : "")} eventkey="3" to={`/be/${beId}/profiles/${profileId}/devices`}>Devices</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "4" ? " active" : "")} eventkey="4" to={`/be/${beId}/profiles/${profileId}/config`}>Configuration</Link>
            </Nav.Item>
            {
                debugSignal.value ? (
                    <Nav.Item>
                        <Link className={"nav-link".concat(activeKey == "5" ? " active" : "")} eventkey="5" to={`/be/${beId}/profiles/${profileId}/edit`}>Edit JSON</Link>
                    </Nav.Item>
                ) : null
            }
        </Nav>
    )
}
